module.exports = __webpack_public_path__ + "media/images/stoneypoint/hero-image-small-0285f9053753e1c44c258432fae82242.png";